export default "__VITE_ASSET__DXpAfPaI__"